import React from 'react';

const PrivacyPolicy = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div style={{
      background: 'radial-gradient(104.43% 103.76% at 49.87% 36.88%, #FFFBE3 10.55%, #FFFBE3 21.07%, #E1FFE3 54.33%)',
      minHeight: '100vh',
      padding: '20px',
      position: 'absolute',
      width: '100%',
      overflowY: 'auto'
    }}>
      <div style={{
        maxWidth: '1000px',
        margin: '0 auto',
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
        overflow: 'visible'
      }}>
        {/* Header */}
        <header style={{
          background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
          color: 'white',
          padding: '40px 30px',
          textAlign: 'center',
          borderRadius: '20px 20px 0 0'
        }}>
          <h1 style={{ fontSize: '2.5em', marginBottom: '10px', fontWeight: 700 }}>
            CHARTE
          </h1>
          <div style={{ fontSize: '1.2em', opacity: 0.95 }}>
            POLITIQUE DE CONFIDENTIALITÉ<br/>
            ET DE PROTECTION DES DONNÉES PERSONNELLES
          </div>
          <div style={{
            marginTop: '15px',
            padding: '8px 20px',
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '20px',
            display: 'inline-block',
            fontSize: '0.9em'
          }}>
            Mise à jour du 26 juillet 2023
          </div>
        </header>

        {/* Navigation */}
        <nav style={{
          background: '#f8f9fa',
          padding: '20px 30px',
          borderBottom: '1px solid #e0e0e0',
          position: 'sticky',
          top: 0,
          zIndex: 100
        }}>
          <div style={{ fontWeight: 600, color: '#4CAF50', marginBottom: '10px' }}>
            Navigation rapide
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {[
              { id: 'responsable', label: 'Responsable' },
              { id: 'donnees', label: 'Données collectées' },
              { id: 'utilisation', label: 'Utilisation' },
              { id: 'partage', label: 'Partage' },
              { id: 'finalites', label: 'Finalités' },
              { id: 'conservation', label: 'Conservation' },
              { id: 'droits', label: 'Vos droits' },
              { id: 'contact', label: 'Contact' }
            ].map(section => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                style={{
                  color: '#666',
                  padding: '8px 15px',
                  borderRadius: '8px',
                  fontSize: '0.9em',
                  background: 'white',
                  border: '1px solid #e0e0e0',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)';
                  e.target.style.color = 'white';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'white';
                  e.target.style.color = '#666';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                {section.label}
              </button>
            ))}
          </div>
        </nav>

        {/* Content */}
        <div style={{ padding: '40px 30px' }}>
          {/* Introduction */}
          <section id="introduction">
            <div style={{
              background: 'linear-gradient(135deg, rgba(76, 175, 80, 0.1) 0%, rgba(46, 125, 50, 0.1) 100%)',
              padding: '20px',
              borderRadius: '10px',
              marginBottom: '40px',
              border: '1px solid rgba(76, 175, 80, 0.3)',
            }}>
              <p style={{ marginBottom: '15px' }}>
                Vous visitez notre Site Web ou l'application Pikkopay (désignés ensemble ci-après le « Site ») :
                nous sommes très concernés par la protection de votre vie privée et souhaitons établir avec vous des relations de confiance.
              </p>
              <p>
                <strong>Notre Site s'adresse à des personnes âgées de 18 ans et plus.</strong> Nous ne collectons pas délibérément
                d'informations relatives à des mineurs, lesquels ne sont pas autorisés à s'y inscrire.
              </p>
            </div>
          </section>

          {/* Section 1 - Responsable */}
          <section id="responsable" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              QUI EST LE RESPONSABLE DU TRAITEMENT DE VOS DONNÉES PERSONNELLES ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Notre société est responsable du traitement de vos données personnelles collectées sur notre Site
              et nous mettons tout en œuvre pour les protéger.
            </p>
            <p style={{ marginBottom: '15px' }}>
              Pour tous commentaires, questions ou demandes relatives à la présente Charte, veuillez nous contacter
              aux coordonnées suivantes :
            </p>
            <div style={{
              background: '#f8f9fa',
              padding: '25px',
              borderRadius: '12px',
              margin: '20px 0',
              borderLeft: '4px solid #4CAF50'
            }}>
              <p style={{ marginBottom: '8px' }}><strong style={{ color: '#4CAF50' }}>Société :</strong> PIKKOPAY</p>
              <p style={{ marginBottom: '8px' }}><strong style={{ color: '#4CAF50' }}>Siège social :</strong> 2 rue Gustave Eiffel, 10430 Rosières-près-Troyes</p>
              <p style={{ marginBottom: '8px' }}><strong style={{ color: '#4CAF50' }}>Téléphone :</strong> 06 42 49 80 34</p>
              <p style={{ marginBottom: '8px' }}><strong style={{ color: '#4CAF50' }}>Email :</strong> contact@pikkopay.fr</p>
              <p style={{ marginBottom: '8px' }}><strong style={{ color: '#4CAF50' }}>Directeur de publication :</strong> Vincent Terrasse</p>
              <p><strong style={{ color: '#4CAF50' }}>DPO :</strong> Vincent Terrasse</p>
            </div>
          </section>

          {/* Section 2 - Données collectées */}
          <section id="donnees" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              QUELLES DONNÉES PERSONNELLES COLLECTONS-NOUS ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Les données que nous collectons sont strictement confidentielles et nous ne les divulguons pas à des tiers.
              Nous les collectons des manières décrites ci-après.
            </p>

            <h3 style={{ color: '#2E7D32', fontSize: '1.3em', marginTop: '20px', marginBottom: '15px' }}>
              2.1 LES DONNÉES QUE VOUS NOUS FOURNISSEZ
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nous collectons les données personnelles que vous déclarez volontairement depuis un formulaire de collecte
              lors de vos visites sur notre Site.
            </p>
            <ul style={{ marginLeft: '30px', marginBottom: '15px' }}>
              <li style={{ marginBottom: '10px' }}>
                des données de contact, telles que vos civilité, nom, adresse e-mail, adresse postale, numéro de
                téléphone fixe et/ou mobile, code interne de traitement permettant l'identification et vos réseaux sociaux ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                vos références de connexion au(x) Service(s), telles que nom d'utilisateur et mot de passe ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                vos modes de paiement (numéro d'une carte de crédit par exemple).
              </li>
            </ul>

            <h3 style={{ color: '#2E7D32', fontSize: '1.3em', marginTop: '20px', marginBottom: '15px' }}>
              2.2 LES DONNÉES RECUEILLIES AUPRÈS D'AUTRES SOURCES
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nous pouvons également obtenir vos coordonnées et autres informations personnelles auprès d'autres parties tierces.
            </p>

            <h3 style={{ color: '#2E7D32', fontSize: '1.3em', marginTop: '20px', marginBottom: '15px' }}>
              2.3 LES DONNÉES DE L'UTILISATION DU SERVICE, Y COMPRIS LES COOKIES
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Lors de votre navigation sur notre Site des cookies et autres traceurs sont déposés sur votre navigateur.
            </p>
            <div style={{
              background: '#fff3cd',
              borderLeft: '4px solid #ffc107',
              padding: '15px',
              margin: '15px 0',
              borderRadius: '5px'
            }}>
              <p style={{ marginBottom: '10px' }}>
                <strong>Important :</strong> Les Cookies techniques et fonctionnels sont nécessaires au bon fonctionnement
                du Site et ne requièrent pas de consentement de votre part.
              </p>
              <p>
                Les Cookies publicitaires, de réseaux sociaux, de personnalisation de contenu et d'analyse d'audience
                sont soumis à votre consentement express.
              </p>
            </div>
          </section>

          {/* Section 3 - Utilisation */}
          <section id="utilisation" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              3. COMMENT UTILISONS-NOUS VOS DONNÉES PERSONNELLES ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Selon les relations que nous avons ensemble, nous utilisons vos données personnelles pour :
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>Fournir, activer et gérer votre accès au Site et votre utilisation de celui-ci ;</li>
              <li style={{ marginBottom: '10px' }}>Traiter et répondre à une demande, une commande ou à toute autre transaction ;</li>
              <li style={{ marginBottom: '10px' }}>Fournir un support technique, un service ou produit complémentaire ;</li>
              <li style={{ marginBottom: '10px' }}>Améliorer le Site et développer nos autres produits et services ;</li>
              <li style={{ marginBottom: '10px' }}>Offrir un contenu personnalisé ;</li>
              <li style={{ marginBottom: '10px' }}>Répondre à vos demandes, recherches, commentaires et préoccupations ;</li>
              <li style={{ marginBottom: '10px' }}>Notifier les modifications, mises à jour et autres annonces ;</li>
              <li style={{ marginBottom: '10px' }}>Nous conformer à nos obligations légales.</li>
            </ul>
          </section>

          {/* Section 4 - Partage */}
          <section id="partage" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              4. AVEC QUI POUVONS-NOUS PARTAGER VOS DONNÉES ?
            </h2>

            <h3 style={{ color: '#2E7D32', fontSize: '1.3em', marginTop: '20px', marginBottom: '15px' }}>
              4.1 VOTRE SOCIÉTÉ
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Si vous accédez au Site par l'intermédiaire de votre structure, vos données personnelles et certaines
              données d'utilisation collectées par le Site peuvent être accessibles et partagées avec le gestionnaire
              de votre structure aux fins d'analyse de l'utilisation du Site.
            </p>

            <h3 style={{ color: '#2E7D32', fontSize: '1.3em', marginTop: '20px', marginBottom: '15px' }}>
              4.2 APPLICATION TIERCE
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nos Services peuvent vous donner accès à des applications tierces auxquelles ils sont reliés.
            </p>

            <h3 style={{ color: '#2E7D32', fontSize: '1.3em', marginTop: '20px', marginBottom: '15px' }}>
              4.3 PRESTATAIRES DE SERVICE
            </h3>
            <p style={{ marginBottom: '15px' }}>
              Nous partageons des informations avec nos prestataires de services, tels que banques ou établissements
              de crédit, fournisseurs d'accès internet, conseils, prestataires informatiques, marketing.
            </p>
          </section>

          {/* Section 5 - Finalités */}
          <section id="finalites" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              5. QUELLES SONT LES FINALITÉS DU TRAITEMENT ?
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Nous collectons ou traitons vos données personnelles dans le respect du RGPD pour les finalités suivantes :
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>
                répondre à l'intérêt légitime de notre société ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                réaliser une vente avec vous ou répondre à votre demande ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                nous conformer à toute obligation légale ;
              </li>
              <li style={{ marginBottom: '10px' }}>
                prévenir la fraude.
              </li>
            </ul>
          </section>

          {/* Section 6 - Conservation */}
          <section id="conservation" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              6. COMBIEN DE TEMPS CONSERVONS-NOUS VOS DONNÉES ?
            </h2>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>3 ans</strong> à compter du dernier contact pour un prospect
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>18 mois</strong> pour les statistiques de mesure d'audience
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>10 ans</strong> en archivage intermédiaire après la dernière activité
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Pendant toute la durée</strong> de la procédure, en cas de contentieux
              </li>
            </ul>
          </section>

          {/* Section 7 - Droits */}
          <section id="droits" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              11. VOS DROITS SUR VOS DONNÉES PERSONNELLES
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Vous avez des droits garantis par les lois sur la protection de la vie privée et des données en Europe
              (RGPD, Chapitre III). Vous pouvez exercer gratuitement :
            </p>
            <ul style={{ marginLeft: '30px' }}>
              <li style={{ marginBottom: '10px' }}>le droit à l'information et le droit d'accès ;</li>
              <li style={{ marginBottom: '10px' }}>le droit de rectification ou d'effacement (droit à l'oubli) ;</li>
              <li style={{ marginBottom: '10px' }}>le droit à la limitation du traitement ;</li>
              <li style={{ marginBottom: '10px' }}>le droit d'opposition au traitement ;</li>
              <li style={{ marginBottom: '10px' }}>le droit d'introduire une réclamation auprès de la CNIL ;</li>
              <li style={{ marginBottom: '10px' }}>le droit à la portabilité de vos données.</li>
            </ul>

            <div style={{
              background: '#f8f9fa',
              padding: '25px',
              borderRadius: '12px',
              margin: '20px 0',
              borderLeft: '4px solid #4CAF50'
            }}>
              <p style={{ fontWeight: 'bold', marginBottom: '15px' }}>
                Pour exercer vos droits, vous pouvez nous contacter :
              </p>
              <p style={{ marginBottom: '8px' }}>
                • Par email : contact@pikkopay.fr
              </p>
              <p>
                • Par courrier : PIKKOPAY, 2 rue Gustave Eiffel, 10430 Rosières-près-Troyes
              </p>
            </div>
          </section>

          {/* Section Contact */}
          <section id="contact" style={{ marginBottom: '40px' }}>
            <h2 style={{
              color: '#4CAF50',
              fontSize: '1.8em',
              marginBottom: '20px',
              paddingBottom: '10px',
              borderBottom: '2px solid #4CAF50'
            }}>
              13. CONTACT
            </h2>
            <p style={{ marginBottom: '15px' }}>
              Si vous avez des commentaires ou des questions concernant la présente politique de confidentialité,
              veuillez nous contacter par courrier électronique à l'adresse suivante :
              <a href="mailto:contact@pikkopay.fr" style={{ color: '#4CAF50', marginLeft: '5px' }}>
                contact@pikkopay.fr
              </a>
            </p>
            <p>
              Vous pouvez également déposer une plainte auprès de la Commission Nationale de l'Informatique
              et des Libertés (CNIL), régulateur des données personnelles en France.
            </p>
          </section>
        </div>

        {/* Footer */}
        <footer style={{
          background: '#2c3e50',
          color: 'white',
          padding: '30px',
          textAlign: 'center',
          borderRadius: '0 0 20px 20px'
        }}>
          <p style={{ marginBottom: '10px', color: 'white' }}>© 2023 PIKKOPAY - Tous droits réservés</p>
          <p style={{ marginBottom: '10px', color: 'white' }}>
            Pour toute question :
            <a href="mailto:contact@pikkopay.fr" style={{ color: '#4CAF50', marginLeft: '5px' }}>
              contact@pikkopay.fr
            </a>
          </p>
          <p style={{ color: 'white' }}>2 rue Gustave Eiffel, 10430 Rosières-près-Troyes</p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
